import Box from "@amzn/meridian/esm/components/box";
import Masthead, { MastheadLink, MastheadTitle } from "@amzn/meridian/esm/components/masthead";
import Theme from "@amzn/meridian/esm/components/theme";
import { TABS, VIEWS } from "../constants";

/**
 * SessionHeader - Tab navigation header for the active session.
 * Shows Assistant, Agenda, and Action Items tabs.
 * Clicking a tab sets the selected tab and resets the view to MAIN.
 */
const SessionHeader = ({ view, selectedTab, onTabClick }) => (
  <Theme tokens={{ mastheadLinkIndicatorColor: "#006D5B" }}>
    <Masthead size="large">
      <MastheadLink
        selected={view === VIEWS.MAIN && selectedTab === TABS.ASSISTANT}
        onClick={onTabClick(TABS.ASSISTANT)}
      >
        Assistant
      </MastheadLink>
      <MastheadLink
        selected={view === VIEWS.MAIN && selectedTab === TABS.AGENDA}
        onClick={onTabClick(TABS.AGENDA)}
      >
        Agenda
      </MastheadLink>
      <MastheadLink
        selected={view === VIEWS.MAIN && selectedTab === TABS.ACTION_ITEMS}
        onClick={onTabClick(TABS.ACTION_ITEMS)}
      >
        Action Items
      </MastheadLink>
    </Masthead>
  </Theme>
);

export default SessionHeader;
